import type { DeepPartial } from '@luna/utils-ts';
import type { StatementDisplayType } from '@retail/investments-types';

import type { Statements } from '../../types/Statements';

export const statementsHRFeatureConfig: DeepPartial<Statements> = {
    hasPaging: true,
    sendStatementIdAsQueryParam: true,
    showCoreStatements: true,
    supportedStatementTypes: ['CONFIRMATIONS'] as StatementDisplayType[],
};
